import { IElement } from "core-integration/src/store/elements/types";
import { useTrackingContext } from "../contexts/TrackingContext";

/**
 * Returns a handler that fires a "club referral" click_track event when a user
 * follows a player's news "More info" link through to the club page.
 */
export const useElementNewsClickTracking = (element: IElement | undefined) => {
  const { fireClickTrackEvent } = useTrackingContext();

  return (clickUrl?: string | null) => {
    if (!element || !clickUrl) {
      return;
    }

    const pathNameFormatted = window.location.pathname.replace(
      /^\/|-/g,
      (match) => (match === "-" ? " " : ""),
    );

    fireClickTrackEvent(
      {
        event_component: "outbound link click",
        event_category: "club referral",
        event_type: "player availability",
        event_detail: String(element.team_code),
        click_url: clickUrl,
        click_location: "player availability",
        player_id: element.code,
      },
      `fantasy ${pathNameFormatted}`,
    );
  };
};
